import React from "react";
import styles from "../../pages/styles";

const ImageText = ({ title, desc, img, bgcolor }) => {
  return (
    <div className="px-4 md:px-20 pt-8 md:pt-10 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
        <div className="flex-1 text-center md:text-left">
          <h1 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>
            <span className="relative inline-block">
              {title}
              <span className="absolute shadow-sm bottom-0 left-1 w-full h-2 bg-pinkprimary/70 -z-10 -skew-x-[30deg] rounded-sm"></span>
            </span>{" "}
            Program
          </h1>
          <p className={`${styles.paragraph} max-w-xl mx-auto md:mx-0`}>{desc}</p>
        </div>
        <div className="flex-1 flex justify-center items-end">
          <img
            src={img}
            alt={`${title} Program`}
            className="w-full max-w-[500px] rounded-2xl"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageText;
